// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ULXb7","label":"styles_label__2PDQi"};